import React, { useState, useEffect } from 'react';
import { Button, Table, Input, FormGroup, Label, Row, Col } from 'reactstrap';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import './StyleCambioPrecio.css';
import Utils from '../../../../utils/Utils';

export const CambioPrecioTabTable = (props) => {
  
  const [Farmacias, setFarmacias] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [selectedFarmacia, setSelectedFarmacia] = useState(""); // Estado para farmacia seleccionada.
  const [selectedCategoria, setSelectedCategoria] = useState(""); // Estado para categoría seleccionada.
  const [productsData, setProductsData] = useState([]); // Listado de productos obtenidos de base de datos.
  const [filteredProducts, setFilteredProducts] = useState([]); // Productos filtrados por descripción o categoría.
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [porcentajeVariacion, setPorcentajeVariacion] = useState(""); // Nuevo estado para porcentaje de variación.
  const [cifraAproximacion, setCifraAproximacion] = useState(""); // Nuevo estado para cifra de aproximación.
  const [descripcionFiltro, setDescripcionFiltro] = useState(""); // Estado para el filtro de descripción.
  const [selectAll, setSelectAll] = useState(false); // Estado para manejar selección de todos los productos.

   // HOOKS DE CARGA INICIAL
   useEffect(() => {
    if (props.keyTab === '8') {
      ObtencionDatos();
      limpiarDatos();
    }
  }, [props.keyTab]);

  // useEffect que se ejecuta solo cuando cambia la farmacia y la opción no es "Seleccione farmacia"
  useEffect(() => {
    if (selectedFarmacia && selectedFarmacia !== "default") {
      ObtenerDatosProducts();
    } else {
      limpiarDatos(); // Limpia los productos si no hay una farmacia seleccionada
    }
  }, [selectedFarmacia]);

  // useEffect para filtrar productos cuando se cambia la descripción o categoría
  useEffect(() => {
    filtrarProductos();
  }, [descripcionFiltro, selectedCategoria, productsData]);


  // Limpia los productos almacenados
  const limpiarDatos = () => {
    setProductsData([]);
    setFilteredProducts([]);
    setIsButtonDisabled(true);
    setSelectAll(false);
    setSelectedFarmacia("default");
    setSelectedCategoria("default");
    setPorcentajeVariacion("");
    setCifraAproximacion("");
  };
  
  // Maneja el cambio en el checkbox individual
  const handleCheckboxChange = (id) => {
    const updatedProducts = productsData.map(product =>
      product.product_id === id ? { ...product, selected: !product.selected } : product
    );
    setProductsData(updatedProducts);
    setFilteredProducts(updatedProducts);
    setIsButtonDisabled(!updatedProducts.some(product => product.selected));
  };


  // Maneja el checkbox para seleccionar/deseleccionar todos los productos
  const handleSelectAllChange = () => {
    const updatedProducts = filteredProducts.map(product => ({ ...product, selected: !selectAll }));
    setProductsData(updatedProducts);
    setFilteredProducts(updatedProducts);
    setSelectAll(!selectAll);
    setIsButtonDisabled(!updatedProducts.some(product => product.selected || !selectAll));
  };

  // LLamo la api de carga de datos iniciales.
  const ObtencionDatos = async () => {
    try {
      const response = await Utils.getStorsCagegory();
      setFarmacias(response.stores);
      setCategorias(response.categories);
    } catch (err) {
      console.log(err);
      Swal.fire({
        title: "Error al cargar los datos iniciales.",
        icon: "error",
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  // Obtenemos los datos segun el filtro de farmacias
  const ObtenerDatosProducts = async () => {
    try {
      const response = await Utils.getStoreData(selectedFarmacia);

      setProductsData(response.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        title: "Error al cargar los datos iniciales.",
        icon: "error",
        showConfirmButton: false,
        timer: 3000
      });
    }
  };
  
  // Filtrar productos por descripción y categoría
  const filtrarProductos = () => {
    let filtered = productsData;

    // Filtrar por descripción si hay texto en el filtro
    if (descripcionFiltro) {
      filtered = filtered.filter(product =>
        product.product_description.toLowerCase().includes(descripcionFiltro.toLowerCase())
      );
    }

    // Filtrar por categoría seleccionada
    if (selectedCategoria && selectedCategoria !== "default") {
      filtered = filtered.filter(product =>
        product.product_category_name === selectedCategoria
      );
    }

    setFilteredProducts(filtered);
  };
  
  const handleConfirm = async () => {
    if (!porcentajeVariacion || !cifraAproximacion) {
      Swal.fire({
        title: 'Debe asignar un porcentaje de variación y cifra de aproximación.',
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    
    if (parseFloat(porcentajeVariacion) > 75) {
      Swal.fire({
        title: 'El porcentaje de variación no puede ser mayor a 75.',
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    const cifraValue = parseFloat(cifraAproximacion);
    if (cifraValue > 0.00 && cifraValue.toFixed(2) !== cifraAproximacion) {
      Swal.fire({
        title: 'La cifra de aproximación debe ser un número con hasta 2 decimales y no puede ser mayor a 0.00.',
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    const selectedProducts = productsData
      .filter(product => product.selected) // Filtrar productos seleccionados
      .map(product => ({
        product_id: product.product_id,
        porcentaje: parseFloat(porcentajeVariacion), // Asegúrate de convertir a número
        cifra_aproximacion: parseFloat(cifraAproximacion) // Asegúrate de convertir a número
      }));
  
    if (selectedProducts.length === 0) {
      Swal.fire({
        title: 'Debe seleccionar al menos un producto.',
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      });
      return;
    }
  
    const dataToSend = {
      products: selectedProducts,
      store_id: selectedFarmacia // Asegúrate de tener el ID de la farmacia
    };
  
    // Llama a la función para actualizar precios
    await actualizarPrecios(dataToSend);
  };
  

  // metodo que manda a bd a actualizar los precios de las presentaciones seleccionadas.
  const actualizarPrecios = async (data) => {
    try {
      const response = await Utils.datePreciosBD(data);
      
      if (response.status === 201) {
        Swal.fire('Cambios realizados con éxito', '', 'success');
        limpiarDatos(); // Otras acciones después de una actualización exitosa
      }
    } catch (error) {
      console.error('Error al actualizar precios:', error);
      Swal.fire({
        title: 'Error al aplicar cambios.',
        icon: 'error',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar'
      });
    }
  };

  return (
    <div className="product-container p-3">
      <Row className="mb-3">
        <Col md={3}>
          <FormGroup>
            <Label for="pharmacySelect">Elegir Farmacia:</Label>
            <Input 
              type="select" 
              name="select" 
              id="pharmacySelect"
              value={selectedFarmacia}
              onChange={(e) => setSelectedFarmacia(e.target.value)}
            >
              <option value="default">Seleccione farmacia</option>
              {Farmacias.map(farmacia => (
                <option key={farmacia.id} value={farmacia.id}>{farmacia.name}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="categorySelect">Categoría:</Label>
            <Input 
              type="select" 
              name="select" 
              id="categorySelect"
              value={selectedCategoria}
              onChange={(e) => setSelectedCategoria(e.target.value)}
            >
              <option value="default">Seleccione categoría</option>
              {categorias.map(categoria => (
                <option key={categoria.id} value={categoria.name}>{categoria.name}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="descripcionFiltro">Buscar por Descripción:</Label>
            <Input 
              type="text"
              value={descripcionFiltro}
              onChange={(e) => setDescripcionFiltro(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="porcentajeVariacion">Porcentaje de Variación:</Label>
            <Input 
              type="number" 
              value={porcentajeVariacion}
              onChange={(e) => setPorcentajeVariacion(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label for="cifraAproximacion">Cifra de Aproximación:</Label>
            <Input 
              type="number" 
              step="0.01" 
              value={cifraAproximacion}
              onChange={(e) => setCifraAproximacion(e.target.value)}
            />
          </FormGroup>
        </Col>
        
      </Row>

      <Table responsive striped hover className="product-table">
        <thead className="thead-dark">
          <tr>
            <th>ID Producto</th>
            <th>Descripción del Producto</th>
            <th>ID Presentación</th>
            <th>Categoria</th>
            <th>Costo Actual</th>
            <th>Precio Actual</th>
            <th>Margen Actual</th>
            <th>
              Seleccionar
              <Input 
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllChange}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map(product => (
            <tr key={product.product_id}>
              <td>{product.product_id}</td>
              <td>{product.product_description}</td>
              <td>{product.presentation_id}</td>
              <td>{product.product_category_name}</td>
              <td>Q. {parseFloat(product.avg_product_unit_cost).toFixed(2)}</td>
              <td>Q. {parseFloat(product.price).toFixed(2)}</td>
              <td>{parseFloat(product.marge_actual).toFixed(2)}%</td>
              <td>
                <Input
                  type="checkbox"
                  checked={product.selected || false}
                  onChange={() => handleCheckboxChange(product.product_id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Button color="primary" onClick={handleConfirm} disabled={isButtonDisabled}>
        Aplicar Cambios
      </Button>
    </div>
  );
};